
import config from './config';

const API_BASE_URL = config.API_BASE_URL;

class ProductService {
  static async getAllProducts() {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/externe-get-list-products`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }
  static async getProductById(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/externe-get-product-by-id/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Produit non trouvé');
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  }

  static async getProducts(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/get-list-products`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }

  static async getProductByIdAuth(id, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/get-product-by-id/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  }

  static async getProductByBarcode(barcode, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/get-product-by-barcode/${barcode}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching product by barcode:', error);
      throw error;
    }
  }

  static async getProductsByType(type, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/get-products-by-type/${type}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching products by type:', error);
      throw error;
    }
  }

  static async addProduct(productData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/add-product`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(productData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error adding product:', error);
      throw error;
    }
  }

  static async updateProduct(productId, productData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/update-product/${productId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(productData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  }

  static async updateProductType(productId, newType, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/update-product-type/${productId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ newType }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error updating product type:', error);
      throw error;
    }
  }

  static async deactivateProduct(productId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/desactiver/${productId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return true;
    } catch (error) {
      console.error('Error deactivating product:', error);
      throw error;
    }
  }

  static async deleteProduct(productId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/Product/delete-product/${productId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  }

 
  static async filterProducts(filterRequest) {
    try {
      const response = await fetch(`${API_BASE_URL}/ProductFilter/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filterRequest),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error filtering products:', error);
      throw error;
    }
  }


  static async getFilterOptions(category, subCategory = null) {
    try {
      const url = subCategory 
        ? `${API_BASE_URL}/ProductFilter/options/${encodeURIComponent(category)}/${encodeURIComponent(subCategory)}`
        : `${API_BASE_URL}/ProductFilter/options/${encodeURIComponent(category)}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching filter options:', error);
      throw error;
    }
  }

  static mapProductToFrontend(product) {
    let technicalSpecs = [];
    let technicalSpecsText = null;
    
    const specsString = product.technicalSpecifications || product.TechnicalSpecifications;
    
    if (specsString) {
      try {
        technicalSpecs = JSON.parse(specsString);
      } catch (e) {
        console.log('Technical specifications is plain text, not JSON');
        technicalSpecsText = specsString;
        technicalSpecs = [];
      }
    }

    return {
      id: product.id || product.Id,
      name: product.name || product.Name,
      price: parseFloat(product.price || product.Price || 0),
      barcode: product.barcode || product.Barcode,
      description: product.description || product.Description,
      adresse_Image_Product: product.adresse_Image_Product || product.Adresse_Image_Product,
      family: product.family || product.Family,
      subFamily: product.subFamily || product.SubFamily,
      category: product.category || product.Category,
      subCategory: product.sub_Category || product.Sub_Category,
      actif: product.actif !== undefined ? product.actif : product.Actif,
      productType: product.productType || product.ProductType || 0,
      reference: product.barcode || product.Barcode,
      brand: product.family || product.Family,
      inStock: product.actif !== false && product.Actif !== false,
      freeDelivery: (product.sub_Category === "Ordinateurs portables" || product.subCategory === "Ordinateurs portables"),
      installment: parseFloat(product.price || product.Price || 0) > 500,
      technicalSpecifications: technicalSpecs,
      technicalSpecificationsText: technicalSpecsText,
    };
  }

  static mapProductToBackend(product) {
    let specsString = null;
    if (product.technicalSpecifications) {
      if (typeof product.technicalSpecifications === 'string') {
        specsString = product.technicalSpecifications;
      } else if (Array.isArray(product.technicalSpecifications)) {
        specsString = JSON.stringify(product.technicalSpecifications);
      }
    } else if (product.technicalSpecificationsText) {
      specsString = product.technicalSpecificationsText;
    }

    return {
      name: product.name,
      price: product.price,
      barcode: product.barcode || product.reference,
      description: product.description,
      adresse_Image_Product: product.adresse_Image_Product,
      family: product.family || product.brand,
      subFamily: product.subFamily,
      category: product.category,
      sub_Category: product.subCategory,
      productType: product.productType || 0,
      actif: product.actif !== undefined ? product.actif : true,
      technicalSpecifications: specsString,
    };
  }
}

export default ProductService;